export const tenantUrl = process.env.ENV === 'prod' ? 'https://meishi.51baibao.com/home' : process.env.ENV === 'dev' ? 'http://localhost:8090' : 'https://beta.meishi.51baibao.com/home'
export const portalUrl = process.env.ENV === 'prod' ? 'https://meishi.51baibao.com/portal' : process.env.ENV === 'dev' ? 'http://localhost:8000' : 'https://beta.meishi.51baibao.com/portal'
export const sellerUrl = process.env.ENV === 'prod' ? 'https://meishi.51baibao.com/seller' : process.env.ENV === 'dev' ? 'http://localhost:8100' : 'https://beta.meishi.51baibao.com/seller'

export const appkey = 'FFFF0N0000000000A354'
export const smsCountDown = 60

export const checkSendSmsBeforeSubmit = process.env.ENV !== 'dev'

export enum UploadType {
  image = 1,
  text,
  audio,
  video,
  application,
}

export const allFileExtension = {
  office: ['.xls', '.xlsx', '.doc', '.docx'],
  image: ['.jpg', '.jpeg', '.png', '.gif'],
  other: ['.pdf', '.rar'],
}
